import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  }

  async toggle(event) {
    const checkbox = event.target
    const enabled = checkbox.checked

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          user: {
            marketing_opt_in: enabled
          }
        })
      })

      if (!response.ok) {
        // Revert the checkbox if the request failed
        checkbox.checked = !enabled
        console.error("Failed to update preference")
      }
    } catch (error) {
      // Revert the checkbox if there was an error
      checkbox.checked = !enabled
      console.error("Error updating preference:", error)
    }
  }
}
